<div class="toolbar" role="banner">
  <div class="logo">
    <img class="back-button" alt="back to home" src="assets/img/back.svg" tabindex="0" (keyup.enter)="backToHome()"
      (click)="backToHome()" />
    <img class="logo-img" alt="world of animals logo" angulartics2On="click" angularticsAction="logo"
      angularticsCategory="World of animal Header" angularticsLabel="logo_homepage"
      src="assets/img/{{ 'woa.woaLogo'| translate }}" tabindex="0" (keyup.enter)="logoClicked()"
      (click)="logoClicked()"/>
  </div>
  <div class="action-button">
    <!-- deferred as per DEV-11719  -->
    <!-- <div class="container" id="search">
      <input type="search" aria-labelledby="search" class="search" tabindex="0"
        placeholder="{{ 'woa.findAnimal'| translate }}" />
      <img class="icon" alt="search-button" src="assets/img/search-btn.svg" />
    </div> -->
    <img class="exit" alt="exit-button" tabindex="0" (keyup.enter)="exitToHome()" (click)="exitToHome()"
      src="assets/img/exit-btn.svg" />
  </div>
</div>